import { render } from "./ProductComponent.vue?vue&type=template&id=14cf6530"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/ProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14cf6530"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14cf6530', __exports__)) {
    api.reload('14cf6530', __exports__)
  }
  
  module.hot.accept("./ProductComponent.vue?vue&type=template&id=14cf6530", () => {
    api.rerender('14cf6530', render)
  })

}


export default __exports__